<template>
    <div id="newDetail" :style="'background:url('+newsBg2+')'">
        <div class="contentBox">
            <div class="detailCard">
                <div class="title" style="padding-top: 15px;">
                    <h2>{{ title }}</h2>
                </div>
                <div class="info" v-if="content" v-html="content">
                </div>
                <div class="formated">
                    <el-form :model="formData" class="wenjuan-form">
                        <!-- 动态渲染题目 -->
                        <div class="form-question" v-for="(item, index) in testList" :key="item.id">
                            <!-- 题目标题 -->
                            <label class="question-label">
                                <span class="required" v-if="item.yn_require === 2">*</span>
                                {{ index + 1 }}. {{ item.name }}
                            </label>
                            
                            <!-- 题目说明 -->
                            <div class="question-intro" v-if="item.intro">{{ item.intro }}</div>
                            
                            <!-- 单选题 (test_type_id = 1) -->
                            <el-radio-group 
                                v-if="item.test_type_id === 1" 
                                v-model="formData[`question_${item.id}`]">
                                <el-radio 
                                    v-for="option in parseOptions(item.options)" 
                                    :key="option.option_title" 
                                    :label="option.option_title">
                                    {{ option.option_title }}
                                </el-radio>
                            </el-radio-group>
                            
                            <!-- 多选题 (test_type_id = 5) -->
                            <el-checkbox-group 
                                v-if="item.test_type_id === 5" 
                                v-model="formData[`question_${item.id}`]">
                                <el-checkbox 
                                    v-for="option in parseOptions(item.options)" 
                                    :key="option.option_title" 
                                    :label="option.option_title">
                                    {{ option.option_title }}
                                </el-checkbox>
                            </el-checkbox-group>
                            
                            <!-- 单行文本 (test_type_id = 10) -->
                            <el-input 
                                v-if="item.test_type_id === 10"
                                v-model="formData[`question_${item.id}`]" 
                                :placeholder="item.message || '请输入'">
                            </el-input>
                            
                            <!-- 多行文本 (test_type_id = 15) -->
                            <el-input 
                                v-if="item.test_type_id === 15"
                                type="textarea"
                                v-model="formData[`question_${item.id}`]" 
                                :rows="4"
                                :placeholder="item.message || '请输入'">
                            </el-input>
                            
                            <!-- 图片上传 (test_type_id = 20) -->
                            <el-upload
                                v-if="item.test_type_id === 20"
                                class="upload-demo"
                                :action="uploadUrl"
                                :on-success="(response, file) => handleUploadSuccess(response, file, item.id)"
                                :on-remove="(file) => handleRemove(file, item.id)"
                                :file-list="formData[`question_${item.id}_files`] || []"
                                list-type="picture-card"
                                :limit="5"
                                accept="image/*">
                                <i class="el-icon-plus"></i>
                                <div slot="tip" class="el-upload__tip">
                                    {{ item.message || '支持 jpg/png 格式，单张不超过 5MB，最多上传5张' }}
                                </div>
                            </el-upload>
                            
                            <!-- 提醒信息 -->
                            <div class="question-message" v-if="item.message && item.test_type_id !== 10 && item.test_type_id !== 15 && item.test_type_id !== 20">
                                {{ item.message }}
                            </div>
                        </div>

                        <!-- 提交按钮 -->
                        <div style="text-align: center; margin-top: 40px;">
                            <el-button type="primary" @click="handleSubmit" style="width: 150px; height: 45px; font-size: 16px;">提交</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import newsBg2 from '@/assets/img/newsBg2.jpg'
import axios from 'axios'


export default {
    name: 'WenJuanPage',
    data() {
        return {
            newsBg2: newsBg2,
            title: '',
            content: '',
            testList: [], // 题目列表
            formData: {}, // 动态表单数据
            uploadUrl: 'http://admin.feitem.com/api/common/upload' // 图片上传接口
        }
    },
    watch: {
        // 监听路由参数变化
        '$route.query.id': function(newId, oldId) {
            if (newId !== oldId && newId) {
                // console.log('检测到ID变化:', oldId, '->', newId);
                this.getMetadata(newId);
            }
        }
    },
    mounted() {
        console.log('当前路由参数:', this.$route.query);
        let id = this.$route.query.id;
        console.log('问卷ID:', id);
        this.getMetadata(id);
    },
    methods: {
        async getMetadata(id) {
            try {
                // 如果没有传递 id 参数，尝试从路由中获取，默认为 1
                const questionId = id || this.$route.query.id || 1;
                
                // 清空之前的表单数据
                this.formData = {};
                
                // 获取问卷数据
                let questionData = await this.$root.getquestionData(questionId);
                this.title = questionData.question_info.name || '';
                this.content = questionData.question_info.content || '';
                this.testList = questionData.test_list || [];
                
                // 初始化表单数据
                this.testList.forEach(item => {
                    // 多选题初始化为数组
                    if (item.test_type_id === 5) {
                        this.$set(this.formData, `question_${item.id}`, []);
                    } 
                    // 图片上传题初始化为空数组和文件列表
                    else if (item.test_type_id === 20) {
                        this.$set(this.formData, `question_${item.id}`, []);
                        this.$set(this.formData, `question_${item.id}_files`, []);
                    } 
                    // 其他为空字符串
                    else {
                        this.$set(this.formData, `question_${item.id}`, '');
                    }
                });
            } catch (error) {
                console.error('获取问卷数据失败:', error);
                this.$message.error('加载问卷失败，请刷新重试');
            } finally {
                // 确保在数据加载完成后关闭 loading
                if (this.$root.loadingClose) {
                    this.$root.loadingClose();
                }
            }
        },
        // 解析选项 JSON 字符串
        parseOptions(optionsStr) {
            try {
                return JSON.parse(optionsStr);
            } catch (error) {
                console.error('解析选项失败:', error);
                return [];
            }
        },
        // 将 test_type_id 转为中文类型
        getTypeName(testTypeId) {
            switch (testTypeId) {
                case 1:
                    return '单选';
                case 5:
                    return '多选';
                case 10:
                    return '单行文本';
                case 15:
                    return '多行文本';
                case 20:
                    return '图片上传';
                default:
                    return '其他';
            }
        },
        // 图片上传成功回调
        handleUploadSuccess(response, file, questionId) {
            // console.log('上传成功:', response);
            if (response.code === 1 && response.data) {
                // 将返回的图片url和fullurl添加到答案数组中
                if (!this.formData[`question_${questionId}`]) {
                    this.$set(this.formData, `question_${questionId}`, []);
                }
                // 存储包含url和fullurl的对象
                this.formData[`question_${questionId}`].push({
                    url: response.data.url || response.data,
                    fullurl: response.data.fullurl || response.data
                });
                
                // 更新文件列表用于展示（使用fullurl显示图片）
                if (!this.formData[`question_${questionId}_files`]) {
                    this.$set(this.formData, `question_${questionId}_files`, []);
                }
                this.formData[`question_${questionId}_files`].push({
                    name: file.name,
                    url: response.data.fullurl || response.data
                });
                
                this.$message.success('上传成功');
            } else {
                this.$message.error('上传失败：' + (response.msg || '未知错误'));
            }
        },
        // 图片移除回调
        handleRemove(file, questionId) {
            const index = this.formData[`question_${questionId}_files`].findIndex(f => f.url === file.url);
            if (index > -1) {
                this.formData[`question_${questionId}_files`].splice(index, 1);
                this.formData[`question_${questionId}`].splice(index, 1);
            }
        },
        handleSubmit() {
            // 验证必填项
            let hasEmpty = false;
            let emptyQuestion = '';

            this.testList.forEach((item, index) => {
                if (item.yn_require === 2) { // yn_require = 2 表示必填
                    const value = this.formData[`question_${item.id}`];
                    if (!value || (Array.isArray(value) && value.length === 0)) {
                        hasEmpty = true;
                        emptyQuestion = `第${index + 1}题：${item.name}`;
                    }
                }
            });

            if (hasEmpty) {
                this.$message.warning(`请完成必填项：${emptyQuestion}`);
                return;
            }

            // 准备提交数据（包含问卷标题、每题 name、中文类型以及答案）
            const submitData = {
                question_id: this.$route.query.id || 1,
                question_title: this.title || '',
                answers: []
            };

            // 将 formData 转换为提交格式
            this.testList.forEach(item => {
                const value = this.formData[`question_${item.id}`];
                let answerValue = value;
                let answerData = {
                    name: item.name || '',
                    type: this.getTypeName(item.test_type_id),
                    answer: answerValue
                };

                // 如果是图片上传题，需要单独处理url和fullurl
                if (item.test_type_id === 20 && Array.isArray(value)) {
                    const urls = value.map(img => img.url).join(',');
                    const fullurls = value.map(img => img.fullurl).join(',');
                    answerData.answer = fullurls; // 答案使用fullurl
                    answerData.url = urls; // 额外添加url字段
                    answerData.fullurl = fullurls; // 额外添加fullurl字段
                }
                // 如果是多选题，将数组转为字符串
                else if (Array.isArray(value)) {
                    answerData.answer = value.join(',');
                }

                submitData.answers.push(answerData);
            });

            // console.log('提交的数据:', submitData);

            // 调用提交接口
            this.submitForm(submitData);
        },
        async submitForm(data) {
            try {
                const loading = this.$loading({
                    lock: true,
                    text: '提交中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                
                const response = await axios.post('http://crm.feitem.com/api/message/create', data);
                
                loading.close();
                
                if (response.data.code === 1) {
                    this.$message.success(response.data.msg || '提交成功！');
                    // console.log('提交的数据:', data);
                    // console.log('提交的状态码:', response.data.code);
                    
                    // 提交成功后清空表单
                    this.testList.forEach(item => {
                        if (item.test_type_id === 5) {
                            // 多选题清空为空数组
                            this.$set(this.formData, `question_${item.id}`, []);
                        } else if (item.test_type_id === 20) {
                            // 图片上传题清空为空数组，并清空文件列表
                            this.$set(this.formData, `question_${item.id}`, []);
                            this.$set(this.formData, `question_${item.id}_files`, []);
                        } else {
                            // 其他题型清空为空字符串
                            this.$set(this.formData, `question_${item.id}`, '');
                        }
                    });
                } else {
                    this.$message.error(response.data.msg || '提交失败，请重试');
                }
            } catch (error) {
                console.error('提交失败:', error);
                // this.$message.error('提交失败：' + (error.message || '网络错误'));
            }
        }
    }
}
</script>
<style lang="scss" scoped src="@/assets/css/wenjuanPage.scss"></style>

